import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import update from 'immutability-helper'

import FilePreview from './Messaging/Components/FilePreview'
import MessageFile from './Messaging/Components/MessageFile'
import MessageImage from './Messaging/Components/MessageImage'

import Icon from './Icon/Icon'

class FileUpload extends React.Component {
  constructor() {
    super()

    this.state = {
      isDropzoneActive: false,
      attachments: {},
    }

    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onFileUploadRemove = this.onFileUploadRemove.bind(this)
  }

  componentDidMount() {
    let counter = 0

    window.addEventListener('dragenter', () => {
      this.setState({
        isDropzoneActive: true,
      })
      counter++
    })

    window.addEventListener('dragleave', () => {
      counter--
      if (counter === 0) {
        this.setState({
          isDropzoneActive: false,
        })
      }
    })

    window.addEventListener('drop', () => {
      counter = 0
      this.setState({
        isDropzoneActive: false,
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.attachments !== this.props.attachments) {
      if (this.props.attachments && this.props.attachments.length > 0) {
        const newState = this.props.attachments.map(item => {
          const attributes = {
            id: item.attributes.id,
            name: item.attributes.fileName,
            preview: item.attributes.thumbUrl || item.attributes.url,
            progress: 100,
            size: item.attributes.fileSize,
            type: item.attributes.contentType,
            deleteUrl: item.attributes.deleteUrl,
            isUploaded: true,
          }
          return { [item.attributes.fileName]: attributes }
        })

        const newObject = newState.reduce((result, item) => {
          const key = Object.keys(item)[0]
          result[key] = item[key]

          return result
        })

        this.setState({
          attachments: newObject,
        }, this.updateAttachmentsIdList)
      }
    }
  }

  updateAttachmentsIdList() {
    this.props.getAttachments(Object.values(this.state.attachments).map((file) => file.id))
  }

  handleFileUpload(e, skip = false) {
    let currentAttachments = []

    if (skip === true) {
      currentAttachments = e
    } else {
      [...e.target.files].forEach((file) => {
        if (file.size > 100 * 1024 * 1024) {
          App.events.publish(
            'app:notification:flash:error',
            'Attachment is too big, please try to not exceed 100MBs.'
          )
          return
        } if (this.state.attachments.hasOwnProperty(file.name)) {
          App.events.publish(
            'app:notification:flash:error',
            'You cannot attach file with the same filename'
          )
          return
        }

        currentAttachments.push(file)
      })
    }

    const newAttachmentsState = {}
    currentAttachments.forEach((file) => {
      newAttachmentsState[file.name] = {
        id: null,
        name: file.name,
        progress: 0,
        type: file.type,
        size: file.size,
        isUploaded: false,
      }
    })

    this.setState({
      attachments: update(this.state.attachments, {
        $merge: newAttachmentsState,
      }),
    })

    currentAttachments.forEach((file) => {
      const data = new FormData()
      data.append('file', file)

      axios.post(this.props.uploadUrl, data, { onUploadProgress: this.onUploadProgress.bind(this, file.name) })
        .then(response => this.uploadSuccess(file.name, response))
        .catch(error => this.uploadFail(file.name, error))
    })
  }

  uploadSuccess(fileName, response) {
    if (this.state.attachments[fileName]) {
      this.setState({
        attachments: update(this.state.attachments, {
          [fileName]: {
            $merge: {
              id: response.data[0].id,
              preview: response.data[0].thumbUrl || response.data[0].url,
              isUploaded: true,
            },
          },
        }),
      }, this.updateAttachmentsIdList)
    } else {
      axios.delete(`${this.props.uploadUrl}/${response.data[0].id}`).catch((error) => {})
    }
  }

  uploadFail(fileName, error) {
    const errMsg = error.response.data.errors.join(', ')

    App.events.publish(
      'app:notification:flash:error',
      errMsg || 'Your file failed to attach. Please try again or contact our support'
    )

    this.setState({
      attachments: update(this.state.attachments, {
        $unset: [fileName],
      }, this.updateAttachmentsIdList),
    })
  }

  onUploadProgress(fileName, progressEvent) {
    const uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)

    this.setState({
      attachments: update(this.state.attachments, {
        [fileName]: { $merge: { progress: uploadProgress } },
      }),
    })
  }

  onFileUploadRemove(fileName) {
    const deleteUrl = this.state.attachments[fileName].deleteUrl

    if (deleteUrl) {
      axios.delete(deleteUrl).catch((error) => {})
    }

    this.setState({
      attachments: update(this.state.attachments, {
        $unset: [fileName],
      }),
    }, this.updateAttachmentsIdList)
  }

  onDrop(files) {
    this.setState({
      isDropzoneActive: false,
    })
    this.handleFileUpload(files, true)
  }

  render() {
    const fileUploads = Object.values(this.state.attachments).map((attachment, i) => {
      const dataWrap = {
        attributes: {
          url: attachment.preview,
          fileSize: attachment.size,
          fileName: attachment.name,
        },
      }

      const isImage = attachment.type.indexOf('image') >= 0

      return (
        <div className="attachment__column col-xs-12 col-sm-6 col-md-4 col-lg-3" key={`attachment-wrap-${i}`}>
          <div className="attachment__wrapper">
            <FilePreview
              progress={attachment.progress}
              fileName={attachment.name}
              iconName={isImage ? 'image' : 'file-archive'}
              imgUrl={attachment.preview}
              isProcessing={attachment.progress === 100 && !attachment.isUploaded}
            />
            {isImage ? (
              <MessageImage image={dataWrap} iconName="times" onImageClick={this.onFileUploadRemove} />
            ) : (
              <MessageFile file={dataWrap} iconName="times" removeFile={this.onFileUploadRemove} />
            )}
          </div>
        </div>
      )
    })

    return (
      <Fragment>
        <div className="dropzone-container--grey">
          <Dropzone
            className={`drop-area ${this.state.isDropzoneActive ? 'is-active' : ''}`}
            onDrop={this.onDrop}
          >
            <div className="drop-area__text">
              {this.props.ctaText} <button type="button" className="btn btn-primary">Browse</button>
            </div>
            <Icon type={['fal', 'upload']} color="grey-light" />
          </Dropzone>
        </div>

        {fileUploads.length > 0 && (
          <div className="message__attachments">
            <div className="row">
              {fileUploads}
            </div>
          </div>
        )}
      </Fragment>
    )
  }
}

FileUpload.propTypes = {
  uploadUrl: PropTypes.string.isRequired,
  getAttachments: PropTypes.func.isRequired,
  attachments: PropTypes.array,
  ctaText: PropTypes.string,
}

FileUpload.defaultProps = {
  attachments: [],
  ctaText: 'Drag & drop your files here or ',
  uploadUrl: '/attachments',
}

export default FileUpload
